import { render, staticRenderFns } from "./EmailTemplateDetails.vue?vue&type=template&id=726bb918&"
import script from "./EmailTemplateDetails.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateDetails.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports